import { Add, Delete } from '@mui/icons-material';
import { Button, FormControl, Grid, IconButton, InputLabel, TextField, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import moment from 'moment';
import { Control, Controller, useFieldArray } from 'react-hook-form';
import { useMobileView } from '../../../../../../Hooks/useMobileView';

interface CertificationsSectionProps {
    control: Control<any, any>;
    readOnly?: boolean;
}
export const CertificationSection = ({ control, readOnly = false }: CertificationsSectionProps) => {
    /* ******************** Hooks ******************** */
    const {
        fields,
        remove,
        append
    } = useFieldArray({
        control,
        name: 'Certifications'
    })
    /* ******************** Variables ******************** */
    const { flexDirection } = useMobileView();
    /* ******************** Functions ******************** */
    const handleDelete = (index: number) => {
        remove(index);
    }
    const handleAdd = () => {
        append({title: '', year: ''})
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <>
            {
                fields.map((cert, index) => (
                    <Grid key={cert.id} item display={"flex"} flexDirection={flexDirection} gap={'20px'} >
                        <Grid item display={"flex"} flexDirection={"column"}>
                            <Typography variant='body-small' color={'black.200'} marginBottom={1}>Certification Name</Typography>  
                            <Controller
                                name={`Certifications.${index}.title`}
                                control={control}
                                rules={{required: true}}
                                render={({ field }) =>( 
                                    <FormControl>   
                                        <InputLabel sx={{opacity: 1}}>{field.value ?"":"Certification Name"}</InputLabel>                   
                                        <TextField
                                            {...field}
                                            // error={hasErrors(field.name, errors)}
                                            sx={{
                                                width: "270px"
                                            }}
                                            // onChange={(params: any) => handleNameChange(params.target.value)}
                                        />
                                    </FormControl>
                                )}
                            />   
                        </Grid>
                        <Grid item display={"flex"} flexDirection={"column"}>
                            <Typography variant='body-small' color={'black.200'} marginBottom={1}>Year Obtained</Typography>  
                            <Controller
                                name={`Certifications.${index}.year`}
                                control={control}
                                rules={{required: true}}
                                render={({ field }) =>( 
                                        <DatePicker
                                            {...field}  
                                            disableFuture 
                                            value={field?.value ? moment(field.value): undefined}         
                                            slotProps={{
                                                textField: {
                                                    placeholder: 'Year'
                                                }
                                            }}
                                            views={['year']} 
                                            // onChange={(val: any) => handleYearChange(val)}                                   
                                        />
                                )}
                            />   
                        </Grid>
                        <Grid item display={"flex"} flexDirection={"column"} justifyContent={'center'}>
                                <IconButton size='medium' onClick={() => handleDelete(index)}>
                                    <Delete fontSize='small' color='error'/>
                                </IconButton>
                        </Grid>
                    </Grid>
                ))
            }

            {!readOnly && 
                <Grid item display={"flex"} flexDirection={"row"}>
                    <Button color='primary'  onClick={handleAdd} >
                        <Add fontSize='small' sx={{marginRight: 0.5}}/>Add certification
                    </Button> 
            </Grid>}
        </>
    )
}